import { Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useCallback, useMemo, useState } from "react";
import { TaxModal } from "./TaxModal";
import dayjs from "../../../../../../../configs/dayjs";
import { useAppDispatch } from "../../../../../../../store";
import { setInfoMessage } from "../../../../../../../acions/actionsCreators/messageActions";
import { ITaxInfo } from "../types";
import { Dayjs } from "dayjs";
import { ButtonType } from "antd/es/button";

type Print1098Props = {
  accountNumber: number;
  taxInfo: ITaxInfo | null;
  type?: ButtonType;
  text?: string;
  disabled?: boolean;
  customClassName?: string;
};

export const Print1098 = ({
  accountNumber,
  taxInfo,
  type = "default",
  text = "Tax 1098",
  disabled = false,
  customClassName,
}: Print1098Props) => {
  const dispatch = useAppDispatch();

  const [open, setOpen] = useState<boolean>(false);

  const years: number[] = useMemo(() => {
    if (taxInfo) {
      const { beginningDate } = taxInfo;

      const now: Dayjs = dayjs();

      let beginningYear: number = dayjs(beginningDate).year();

      const currentYear: number = now.year();

      if (beginningYear < currentYear) {
        const values: number[] = [];
        if (beginningYear !== currentYear - 1) {
          values.push(beginningYear);

          while (beginningYear !== currentYear - 2) {
            values.push(++beginningYear);
          }
        }

        if (now.month() === 0) {
          now.date() >= 5 && values.push(currentYear - 1);
        } else {
          values.push(currentYear - 1);
        }

        return values.reverse();
      }

      return [];
    } else {
      return [];
    }
  }, [taxInfo]);

  const openModal = useCallback(() => {
    if (years.length > 0) {
      setOpen(true);
    } else {
      const currentYear = dayjs().year();

      dispatch(
        setInfoMessage(
          `${currentYear} tax report will be available in January ${currentYear + 1}.`,
        ),
      );
    }
  }, [years, dispatch]);

  return (
    <>
      <Button
        icon={<DownloadOutlined />}
        shape="round"
        className={`${customClassName || ""}`}
        type={type}
        onClick={openModal}
        disabled={disabled}
      >
        {text}
      </Button>
      <TaxModal
        open={open}
        accountNumber={accountNumber}
        years={years}
        setOpen={setOpen}
      />
    </>
  );
};
